import { apiClient } from '../lib/api/client';
import type { CoverLetterVersion, GenerateCoverLetterPayload, ImproveCoverLetterPayload } from '../models/cover-letter';

export interface CoverLetterHistoryItem {
    id: string;
    company_name: string;
    job_description: string;
    created_at: string;
}

export const coverLetterService = {
    _historyCache: null as CoverLetterHistoryItem[] | null,

    getCachedHistory: () => coverLetterService._historyCache,

    /**
     * Get history of cover letters
     */
    getCoverLetters: async (): Promise<CoverLetterHistoryItem[]> => {
        const data = await apiClient.get<CoverLetterHistoryItem[]>('/api/cover-letters');
        coverLetterService._historyCache = data;
        return data;
    },

    /**
     * Generates a new cover letter
     */
    /**
     * Generates a new cover letter
     */
    generateCoverLetter: async (payload: {
        resume_id: string,
        job_description?: string,
        job_url?: string,
        company_name?: string
    }) => {
        return apiClient.post<{
            cover_letter_id: string;
            version_id: string;
            content: any;
        }>('/api/generate/cover-letter', payload);
    },

    /**
     * Gets the latest version of a cover letter
     */
    getLatestVersion: async (coverLetterId: string): Promise<CoverLetterVersion> => {
        return apiClient.get<CoverLetterVersion>(`/api/cover-letters/${coverLetterId}/versions/latest`);
    },

    /**
     * Improves a cover letter based on instruction
     */
    improveCoverLetter: async (coverLetterId: string, payload: ImproveCoverLetterPayload): Promise<CoverLetterVersion> => {
        return apiClient.post<CoverLetterVersion>(`/api/cover-letters/${coverLetterId}/improve`, payload);
    }
};
